import React, { useState } from 'react'
import { DatePicker } from 'antd'
import { appDate } from 'utils'
import { Moment } from 'moment'
import './index.less'

export interface AppDateProps {
  value?: string
  onChange?: (value: Moment, text: string) => void
  format?: string
  placeholder?: string
  readonly?: boolean
  error?:boolean
  size?:'normal'|'small'
}

const initState = (props: AppDateProps) =>{
    if(props.readonly) return 'readonly'
    if(props.error) return 'error'
    return 'default'
}


export const AppDate = (props: AppDateProps) => {
  const [value, setValue] = useState(appDate.moment(props.value))
  const [state, setState] = useState(initState(props))

  const hanldChange = (newValue: Moment, returnValue: string) => {
    setValue(newValue);
    setState('default')
    props.onChange && props.onChange(newValue, returnValue);
  }

  let className = props.size && props.size === 'small' ? 'app-date-container-small':'app-date-container'

  return (
    <div className={className}>
      <DatePicker
        onChange={hanldChange}
        placeholder={props.placeholder}
        format = {props.format || 'YYYY-MM-DD'}
        value={value}
        style={{ width: '100%' }}
        disabled={props.readonly || false}
      />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/qcc/AppDate/index.tsx